import { GridCellProps } from '@progress/kendo-react-grid';
import { SyntheticEvent, useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import NumberStepper from 'src/components/design-system/NumberStepper';
import { ViewCatalogProductsContext } from 'src/sections/catalog_products/ViewCatalogProductsContext';
import { useContextSelector } from 'use-context-selector';

const QtyCell = (props: GridCellProps) => {
  const field = props.field || '';
  const value = props.dataItem[field] ?? 0;
  const { dataItem, dataIndex, onChange } = props;

  const selectedCatalog = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.selectedCatalog
  );
  const isSupplierUser = useContextSelector(
    ViewCatalogProductsContext,
    (context) => context.isSupplierUser
  );

  const isExternalSupplier = useMemo(() => selectedCatalog?.catalogType === 2, [selectedCatalog]);

  const handleQuantityChange = useCallback(
    (e: SyntheticEvent, newValue: number) => {
      onChange?.({
        dataIndex,
        dataItem,
        field,
        syntheticEvent: e,
        value: newValue,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={false}
      className="!p-0 w-[100%]"
      title={isExternalSupplier ? 'Click Open External Catalog button to order.' : value.toString()}
    >
      <NumberStepper
        value={value}
        onChange={handleQuantityChange}
        disabled={isExternalSupplier || isSupplierUser}
        className="w-[100%]"
      />
    </GridCellBase>
  );
};

export default QtyCell;
